import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_side-layout/reports_/add-funnel-report')({
  beforeLoad: () => {
    throw redirect({ to: '/funnels/add-funnel-report' as string });
  },
});
